import api from './config';

export const subscriptionsAPI = {
  // Listar todas assinaturas (Admin)
  getAll: async (filters = {}) => {
    const token = localStorage.getItem('token');
    const response = await api.get('/subscriptions', {
      params: filters,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Dashboard de métricas (Admin)
  getDashboard: async () => {
    const token = localStorage.getItem('token');
    const response = await api.get('/subscriptions/dashboard', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Ver própria assinatura
  getMySubscription: async () => {
    const token = localStorage.getItem('token');
    const response = await api.get('/subscriptions/my-subscription', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Listar planos disponíveis
  getPlans: async () => {
    const response = await api.get('/subscriptions/plans');
    return response.data;
  },

  // Verificar se empresa já usou Trial
  checkTrial: async () => {
    const response = await api.get('/subscriptions/check-trial');
    return response.data;
  },

  // Selecionar e contratar plano
  selectPlan: async (planName) => {
    const response = await api.post('/subscriptions/select-plan', {
      planName
    });
    return response.data;
  },

  // Suspender assinatura (Admin)
  suspend: async (id, reason) => {
    const response = await api.post(`/subscriptions/${id}/suspend`, { reason });
    return response.data;
  },

  // Ativar assinatura (Admin)
  activate: async (id, extendDays = 30) => {
    const response = await api.post(`/subscriptions/${id}/activate`, { extendDays });
    return response.data;
  },

  // Alterar plano da própria assinatura (User)
  changeMyPlan: async (planName) => {
    const response = await api.put('/subscriptions/my/plan', {
      planName
    });
    return response.data;
  },

  // Mudar plano (Admin) - mudar plano e preço
  changePlan: async (id, planName) => {
    const token = localStorage.getItem('token');
    // Primeiro buscar o plano para obter o preço
    const plans = await subscriptionsAPI.getPlans();
    const selectedPlan = plans.find(p => p.name === planName);
    
    if (!selectedPlan) {
      throw new Error('Plano não encontrado');
    }

    const response = await api.put(`/subscriptions/${id}/plan`,
      { plan: planName, price: selectedPlan.price },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  },

  // Logs de auditoria (Admin)
  getAuditLogs: async (filters = {}) => {
    const token = localStorage.getItem('token');
    const response = await api.get('/subscriptions/audit-logs', {
      params: filters,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Deletar histórico de mudanças (Master Admin)
  deleteAuditHistory: async () => {
    const token = localStorage.getItem('token');
    const response = await api.delete('/subscriptions/audit', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
};

export default subscriptionsAPI;


